import React from 'react'
import { func, object } from 'prop-types'

import retrieveAndProcessDataForPage from '@/lib/data-for-page-processor-and-retriever'
import createRenderSectionQuery from '@/query/section/render-section'
import StandardMeta from '@/component/Meta/Standard'

import Layout from '@/component/Structure/Layout'
import getUserAgent from './lib/get-user-agent'
import getArticleIds from './lib/get-article-ids'
import appendUser from './lib/append-user'

const SectionPage = ({
  __url,
  section,
  pageData,
  latestMagazineIssue,
  instance
}) => {
  if (!section) return null
  const layout = section?.layouts?.section?.layout

  const images =
    section.images.share_widescreen_1200 &&
    section.images.share_widescreen_1200.length
      ? [
          {
            url: `${section.images.share_widescreen_1200[0].url}.jpg`,
            width: 668,
            height: 504,
            alt: section.name
          }
        ]
      : instance.images.share_landscape_1048 &&
        instance.images.share_landscape_1048.length
      ? [
          {
            url: `${instance.images.share_landscape_1048[0].url}.jpg`,
            width: 1048,
            height: 550,
            alt: section.name
          }
        ]
      : [
          {
            url: instance.darkLogoUrl,
            alt: instance.name
          }
        ]

  return (
    <>
      <StandardMeta
        title={section.metaTitle || section.name}
        description={section.metaDescription}
        seoTitle={section.shareTitle || section.metaTitle || section.name}
        seoDescription={section.shareDescription || section.metaDescription}
        canonicalUrl={pageData.url}
        images={images}
      />
      <Layout
        layout={layout}
        __url={__url}
        section={section}
        instance={instance}
        pageData={pageData}
        latestMagazineIssue={latestMagazineIssue}
      />
    </>
  )
}

SectionPage.propTypes = {
  __url: func.isRequired,
  section: object,
  pageData: object,
  instance: object,
  latestMagazineIssue: object
}

SectionPage.getInitialProps = async (context) => {
  const params = context && context.query
  const query = createRenderSectionQuery()
  const page = parseInt(params && params.page) || 1
  if (context.res) {
    context.res.endTime(`pre-resource-render`)
    context.res.startTime(`section-graphql-request`, 'Section GRAPHQL Request')
  }
  const data = await retrieveAndProcessDataForPage(context, query, { page })
  if (context.res) {
    context.res.endTime(`section-graphql-request`)
    context.res.startTime(`react-render`, 'React Render')
  }
  if (data.error) return data

  const instance = data?.response.instance
  const { userAgent, isDesktop } = getUserAgent(context)
  const section = data && data.response && { ...data.response.resource }
  const url = data && data.vars && data.vars.url
  delete data?.response?.resource?.layouts
  const articleIds = getArticleIds(section.layouts.section.layout)
  let pageData = { url, params, userAgent, isDesktop, articleIds }
  pageData = await appendUser(pageData, context, instance)
  const ctx = { isDesktop }
  return {
    ...data.response,
    section,
    pageData,
    context: ctx
  }
}

export default SectionPage
